var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "main-container" },
    [
      _c(
        "avue-crud",
        {
          ref: "crud",
          attrs: {
            page: _vm.page,
            data: _vm.tableData,
            "table-loading": _vm.tableLoading,
            option: _vm.tableOption,
          },
          on: {
            "update:page": function ($event) {
              _vm.page = $event
            },
            "on-load": _vm.fetchData,
            "search-change": _vm.handleSubmit,
          },
          scopedSlots: _vm._u([
            {
              key: "searchMenu",
              fn: function (ref) {
                var size = ref.size
                return [
                  _c(
                    "el-button",
                    {
                      attrs: { size: size, type: "primary" },
                      on: {
                        click: function ($event) {
                          return _vm.handleUpdate({})
                        },
                      },
                    },
                    [_vm._v(_vm._s(_vm.$t("addOrganDrug.addDrug")))]
                  ),
                ]
              },
            },
            {
              key: "menu",
              fn: function (ref) {
                var row = ref.row
                return [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "text", size: "small" },
                      on: {
                        click: function ($event) {
                          return _vm.handleUpdate(row)
                        },
                      },
                    },
                    [_vm._v(_vm._s(_vm.$t("common.detail")))]
                  ),
                ]
              },
            },
          ]),
          model: {
            value: _vm.formData,
            callback: function ($$v) {
              _vm.formData = $$v
            },
            expression: "formData",
          },
        },
        [
          _c(
            "template",
            { slot: "header" },
            [
              _c(
                "el-tabs",
                {
                  staticClass: "platform-tabs",
                  attrs: { "before-leave": _vm.changeSearch, type: "card" },
                  model: {
                    value: _vm.status,
                    callback: function ($$v) {
                      _vm.status = $$v
                    },
                    expression: "status",
                  },
                },
                _vm._l(_vm.statusList, function (item) {
                  return _c(
                    "el-tab-pane",
                    {
                      key: item.id,
                      attrs: { name: "" + item.id, disabled: _vm.tableLoading },
                    },
                    [
                      _c("span", { attrs: { slot: "label" }, slot: "label" }, [
                        _vm._v(
                          "\n            " +
                            _vm._s("" + item.name) +
                            "\n          "
                        ),
                      ]),
                    ]
                  )
                }),
                1
              ),
            ],
            1
          ),
        ],
        2
      ),
      _vm.showUpdateOrganDrug
        ? _c("updateOrganDrug", {
            ref: "updateOrganDrugRef",
            attrs: { "current-data": _vm.currentData },
            on: { fetchData: _vm.fetchData },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }